/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import SinglePicker from '@/components/Base/SinglePicker';
export default {
  name: 'CustomSearch',
  props: {
    search: {
      type: Object
    }
  },
  components: {
    SinglePicker: SinglePicker,
    Group: Group,
    XInput: XInput
  },
  data: function data() {
    return {
      value: ''
    };
  },
  watch: {
    value: function value(val) {
      // 多选和日期控件 返回值需要将数组改为逗号拼接字符串
      // if ([4, 5, 6].indexOf(this.data.type) !== -1) val = val.join(',')
      this.$emit('input', val);
    }
  },
  methods: {
    resetFields: function resetFields() {
      this.value = '';
    }
  }
};